var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"flex justify-center items-center",staticStyle:{"height":"100%"}},[_c('AscColorChipRenderer',{attrs:{"value":_vm.rank_absolute}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }